import FrontendPanel from "../../Layout/Company";
import TrainingVideos from "../pages/Dashboard/TrainingVideos";
import DiscussionForum from "../pages/Dashboard/DiscussionForum";
import Quiz from "../pages/Dashboard/Quiz";
import DiscussionForumDetails from "../pages/Dashboard/DiscussionForumDetails";
import Course from "../pages/Dashboard/Course";
import Transcript from "../pages/Dashboard/Transcript";
import LoginCompany from "../pages/Dashboard/LoginCompany";
import RegisterCompany from "../pages/Dashboard/RegisterCompany";

export default {
  path: "/company",
  component: FrontendPanel,
  // redirect: '/home',
  children: [
    {
      path: "/dashboard",
      component: TrainingVideos,
      meta: {
          requiresAuth: true,
        title: 'Dashboard'
      }
    },
    {
      path: "/dashboard/transcript",
      component: Transcript,
      meta: {
        // requiresAuth: true,
        title: 'Transcript'

      },
    },
    {
      path: "/dashboard/forum",
      component: DiscussionForum,
      meta: {
        // requiresAuth: true,
        title: 'Discussion Forum'

      },
    },

    {
      path: "/dashboard/forum-details",
      component: DiscussionForumDetails,
      meta: {
        // requiresAuth: true,
        title: 'Discussion Forum Details'

      },
    },
    {
      path: "/dashboard/quiz/:id",
      component: Quiz,
      meta: {
        // requiresAuth: true,
        title: 'Quiz'

      },
    },

    {
      path: "/dashboard/courses/:id",
      component: Course,
      meta: {
        // requiresAuth: true,
        title: 'Course'

      },
    },

    {
      path: "/admin/login",
      name: "admin_login",
      component: LoginCompany,
      meta: {
        requiresVisitor: true,
        title: 'Company Login'

      },
    },
    {
      path: "/admin/register",
      name: "admin_register",
      component: RegisterCompany,
      meta: {
        requiresVisitor: true,
      },
    },
  ],
};
